import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="relative w-full bg-accent-900">
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6 pt-16 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 mb-12">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 mb-6 group">
              <span className="font-heading text-2xl font-bold text-background-50 tracking-tight">
                Superbuy Spreadsheet
              </span>
              <span className="w-2 h-2 rounded-full bg-accent-400 mt-1"></span>
            </Link>

            <form
              data-readdy-form="d9aejit86d4i8fhr8vm0"
              action="https://readdy.ai/api/form/d9aejit86d4i8fhr8vm0"
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="mb-6 max-w-sm"
            >
              <div className="flex items-center gap-2">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Your email for updates"
                  className="flex-1 px-4 py-3 rounded-full bg-transparent border border-background-50/20 text-background-50 placeholder:text-background-50/40 text-sm focus:outline-none focus:border-accent-400 transition-colors duration-200"
                />
                <button
                  type="submit"
                  className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-background-50 hover:bg-accent-400 transition-colors duration-200 flex-shrink-0 cursor-pointer"
                >
                  <i className="ri-notification-3-line text-lg"></i>
                </button>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
            </form>

            <p className="font-heading text-xl md:text-2xl font-bold text-background-50/90 leading-snug mb-2">
              The Smartest Way
            </p>
            <p className="font-heading text-xl md:text-2xl font-bold text-background-50/90 leading-snug">
              to Shop Superbuy.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(6, 12).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/article/superbuy-spreadsheet-complete-guide"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
                >
                  Complete Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
                >
                  Main Store
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-50/10">
          <p className="text-sm text-background-50/40 mb-4 sm:mb-0">
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet. All rights reserved.
          </p>

          <div className="flex items-center gap-3">
            {['ri-twitter-x-line', 'ri-instagram-line', 'ri-reddit-line', 'ri-pinterest-line'].map(
              (icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all duration-200 cursor-pointer"
                  aria-label={`Social media ${icon}`}
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              )
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}